<template>
  <l-rows>
    <a-title :text="this.$t('common.games')" />
    <l-columns>
      <l-columns-column size="4">
        <integration-select
          :value="selectedIntegrationId"
          @input="handleIntegrationSelect"
        />
      </l-columns-column>
      <l-columns-column size="4">
        <games-version-select
          :integration-id="selectedIntegrationId"
          @gameAdd="addGame"
        />
      </l-columns-column>
    </l-columns>
    <back-office-list
      :loading="gamesMeta.loading"
      :list-data="games"
      :columns="columns"
      :selection-change="handleIntegrationGameSelect"
    />
  </l-rows>
</template>

<script>
  import { useAddGameToIntegration, useIntegrationGames, useRemoveGameFromIntegration } from './integrationHooks'
  import { AButton, ATitle, LColumns, LColumnsColumn, LRows } from 'codefabrik-gui-vue'
  import BackOfficeList from '../../components/BackOfficeList'
  import { IntegrationGameActiveBadge, GamesVersionSelect } from '../../components'
  import { mapActions, mapState } from 'vuex'
  import { IntegrationSelect } from '@/components'

  export default {
    name: 'IntegrationGamesList',
    components: { ATitle, IntegrationSelect, BackOfficeList, GamesVersionSelect, LColumns, LColumnsColumn, LRows },
    data () {
      return {
        games: [],
      }
    },
    mixins: [
      useIntegrationGames('games', 'selectedIntegrationId'),
      useAddGameToIntegration('addGame'),
      useRemoveGameFromIntegration('removeGame')
    ],
    computed: {
      ...mapState('integration', ['selectedIntegrationId']),
      columns () {
        return [
          {
            field: 'name',
            header: this.$t('common.name'),
          },
          {
            field: 'version',
            header: this.$t('common.version'),
          },
          {
            field: 'active',
            header: this.$t('common.status'),
            component: IntegrationGameActiveBadge,
            componentProperties: {
              integrationGame: (it) => it
            }
          },
          {
            size: "1",
            contentPosition: 'right',
            component: AButton,
            componentProperties: {
              text: "",
              iconLeft: 'fas fa-minus',
              variant: 'danger'
            },
            componentListeners: {
              click: this.handleDelete
            }
          }
        ]
      },
      integrationOptions () {
        return this.integrations.map(it => {
          return { value: it.id, label: it.name }
        })
      },
    },
    methods: {
      ...mapActions('integration', ['setIntegrationId']),
      handleIntegrationSelect (newValue) {
        this.setIntegrationId(newValue)
        if (this.selectedIntegrationId === null || this.selectedIntegrationId === '') {
          this.games = []
        }
      },
      handleDelete (integrationGame, event) {
        event.stopPropagation()
        this.removeGame({ id: integrationGame.id })
      },
      handleIntegrationGameSelect (integrationGame) {
        this.$router.push({ name: 'integration-game', params: { integrationGameId: integrationGame.id }})
      }
    },
  }
</script>

<style scoped>

</style>
